import { render } from "./MessageGroupFiles.vue?vue&type=template&id=ae28d6ee&scoped=true&ts=true"
import script from "./MessageGroupFiles.vue?vue&type=script&lang=ts"
export * from "./MessageGroupFiles.vue?vue&type=script&lang=ts"

import "./MessageGroupFiles.vue?vue&type=style&index=0&id=ae28d6ee&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae28d6ee"]])

export default __exports__